export default __webpack_public_path__ + "static/media/iconX.129a7425.svg";